export const PAYMENT_AMOUNT_LESS_THAN_MIN = 'PAYMENT_AMOUNT_LESS_THAN_MIN';
export const AMOUNT_REMAINING_LESS_THAN_MIN = 'AMOUNT_REMAINING_LESS_THAN_MIN';